export {
  Browser,
  isIE,
  isFirefox,
  isChrome,
  isDesktop,
  isYandex,
  isVivaldi,
  isSamsung,
  isUC,
  isEdge,
  isOpera,
  isSafari,
  isWindows,
  isMac,
  isLinux,
  isAndroid,
  isIPad,
  isIPhone,
  isIos,
  isTouch,
  browserStr,
  browserVersion,
  browserVersionStr,
  osStr,
  asString,
} from './src/browser-detect';
export {
  isEmbeddedDocument,
  isTabActive,
  isHighDPI,
  supportsDynamicFavicon,
  supportsFancyPeel,
} from './src/feature-detect';
export { isBrowserSupported } from './src/is-browser-supported';
